import React, { useState, useEffect } from"react";
import { promptCardAPI } from"../services/api";
import ChatWindow from"./chat/ChatWindow";
import { ChatInterfaceSkeleton } from"./skeleton/SkeletonComponents";

const UserView = ({ projectId, projectName, engineType = 'T5' }) => {
  const [promptCards, setPromptCards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPromptCards = async () => {
      try {
        setLoading(true);
        console.log("🔄 UserView - 프롬프트 카드 로드 시작 (Engine:", engineType,")");
        // 엔진 타입을 전달하여 해당 엔진의 프롬프트 카드만 가져오기
        const response = await promptCardAPI.getPromptCards(true, false, engineType);
        setPromptCards(response.promptCards || []);
        console.log("✅ UserView - 프롬프트 카드 로드 완료:", response.promptCards?.length || 0,"(", engineType,")");
      } catch (error) {
        console.warn("프롬프트 카드 로드 실패:", error);
        setPromptCards([]);
      } finally {
        setLoading(false);
      }
    };

    loadPromptCards();
  }, [projectId, engineType]);

  if (loading) {
    return <ChatInterfaceSkeleton />;
  }

  return (
    <div className="h-screen bg-white transition-colors duration-300">
      <ChatWindow
        projectId={projectId}
        projectName={projectName}
        promptCards={promptCards}
        engineType={engineType}
      />
    </div>
  );
};

export default UserView;
